//TODO: Utils entry point.
import {TestTypeNumerable} from '../../../../../kits/admin/src/test-results/types/test-panel';
import {enumRemap, mapToEnum} from 'shared/utils';
import {TestType} from '@esgi/main/kits/common';

export function mapTestTypeNumerableToString(testType: TestTypeNumerable) {
	return enumRemap(mapToEnum(testType, TestTypeNumerable), TestTypeNumerable) as TestType;
}